import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from 'seagull';
import { PdfViewer } from '~/components/PdfViewer/PdfViewer';
import styles from './pdfViewerModal.module.scss';
export const PdfViewerModal = (param)=>{
    let { title, getFileUrl, onClose, testId, pdfUniqueName } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'pdf_viewer_confirm'
            },
            secondaryButton: {
                name: 'pdf_viewer_cancel'
            }
        },
        overflowContent: true,
        contentPadding: "small",
        width: "800px",
        height: "calc(100% - 128px)",
        title: title,
        onCloseButtonClick: onClose,
        testId: testId,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.pdfViewerWrapper,
            children: /*#__PURE__*/ _jsx(PdfViewer, {
                getFileUrl: getFileUrl,
                hideSinglePageLoader: true,
                pdfUniqueName: pdfUniqueName
            })
        })
    });
};
